<copo-project-characteristics-solar [guaranteeResponse]="guarantee"
	*ngIf="guarantee.applicationType === 'Magnelis-Solar'">
</copo-project-characteristics-solar>
<copo-project-characteristics-other [guaranteeResponse]="guarantee"
	*ngIf="guarantee.applicationType === 'Magnelis-Other application'">
</copo-project-characteristics-other>
<copo-project-characteristics-building [guaranteeResponse]="guarantee"
	*ngIf="guarantee.applicationType === 'Magnelis-Building'">
</copo-project-characteristics-building>
<copo-project-characteristics-organic [guaranteeResponse]="guarantee"
	*ngIf="guarantee.applicationType === 'Organic Coating'">
</copo-project-characteristics-organic>
<copo-guarantee-type-selector *ngIf="!guarantee.applicationType"></copo-guarantee-type-selector>